const DispCard = ({id,header,title,desc,background,btnText, headerColor, titleSize, titleColor, descColor, descSize, btnColor, btnSize, svg , gradient, noise, animation  }) => {


    return(
      <div className={`w-[278px] h-[356px] flex flex-shrink-0 flex-col items-center rounded-[10px] justify-between py-8 
        relative overflow-hidden ${animation || ''}`}>
  
        {/* Background Layers */}
        <div className={`absolute inset-0  ${gradient || ''} ${background?.startsWith('http') ? '' : background}`}
              style={background?.startsWith("http") ? { backgroundImage: `url(${background})`, backgroundSize: "cover", backgroundPosition: "center", opacity: "0.8" } : {}}
>
            {/* Noise Overlay */}
            {noise && (
            <div className="absolute inset-0 noise-texture opacity-100 mix-blend-overlay"></div>
          )}
        </div>
  
        {/* Content (unchanged layout) */}
        <p className={`font-poppins font-semibold ${headerColor || 'text-white'} relative z-10`}>{header}</p>
        <span className="flex flex-col items-center gap-1 relative z-10">
          <p className={`font-poppins font-semibold ${titleSize || 'text-[18px]'} ${titleColor || 'text-white'}`}>{title}</p>
          <p className={`font-poppins font-semibold ${descSize || 'text-[18px]'} ${descColor || 'text-white'}`}>{desc}</p>
        </span>
        <button className={`flex items-center gap-2 font-poppins font-semibold ${btnSize} ${btnColor || 'text-white'} relative z-10`}>
          {btnText} {svg ?
          <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.885 7.50098H1.5918" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M10.1201 1.47559L15.885 7.49959L10.1201 13.5246" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          : ''}
        </button>
      </div>
    )}


export default DispCard;



 // const products = [
  //   {
  //     id: 1,
  //     header: 'shop groceries with Ai',
  //     headerColor:'',
  //     title: 'BAZ-1',
  //     titleSize: 'text-[24px]',
  //     titleColor: 'text-white',
  //     desc: '',
  //     descColor: '',
  //     descSize: '',
  //     background: 'bg-gradient-to-r from-green-500 to-lime-700',
  //     animation: 'animate-pulse',
  //     noise: true,
  //     btnText: 'Shop Now',
  //     btnColor: '',
  //     btnSize: '',
  //     svg: true,
  //   },
  //   {
  //     id: 2,
  //     header: 'Get Fresh Farm Produce',
  //     title: 'Mobimart',
  //     desc: '',
  //     background: 'bg-gradient-to-r from-[#FF8A00] to-blue-600',
  //     btnText: 'Coming Soon',
  //     headerColor:'',
  //     animation: 'animate-pulse',
  //     noise: true,
  //     titleSize: 'text-[24px]',
  //     titleColor: '',
  //     descColor: '',
  //     descSize: '',
  //     btnColor: '',
  //     btnSize: '',
  //     svg: '',
  //   }
  // ]


  // const research = [
  //   {
  //     id: 1,
  //     title: 'Fisherman Soup:',
  //     desc: 'A Nigerian Masterpiece',
  //     background: 'bg-purple-700',
  //     btnText: 'Read More',
  //     headerColor:'',
  //     titleSize: '',
  //     titleColor: '',
  //     descColor: '',
  //     descSize: '',
  //     btnColor: '',
  //     btnSize: '',
  //     svg: true,
  //   },
  //   {
  //     id: 2,
  //     title: 'Jollof Rice:',
  //     desc: 'The Nation’s Pride',
  //     background: 'bg-purple-700',
  //     btnText: 'Read More',
  //     headerColor:'',
  //     titleSize: '',
  //     titleColor: '',
  //     descColor: '',
  //     descSize: '',
  //     btnColor: '',
  //     btnSize: '',
  //     svg: true,
  //   },
  //   {
  //     id: 3,
  //     title: 'Fisherman Soup:',
  //     desc: 'A Nigerian Masterpiece',
  //     background: 'bg-purple-700',
  //     btnText: 'Read More',
  //     headerColor:'',
  //     titleSize: '',
  //     titleColor: '',
  //     descColor: '',
  //     descSize: '',
  //     btnColor: '',
  //     btnSize: '',
  //     svg: true,
  //   },
  // ]


  // const stories = [
  //   {
  //     id: 1,
  //     title: 'Absolute Cinema:',
  //     desc: 'A Founder Story',
  //     background: 'bg-blue-700',
  //     btnText: 'Follow Story',
  //     headerColor:'',
  //     titleSize: '',
  //     titleColor: '',
  //     descColor: '',
  //     descSize: '',
  //     btnColor: '',
  //     btnSize: '',
  //     svg: true,
  //   },
  //   {
  //     id: 2,
  //     title: 'The story of two comets:',
  //     desc: 'A Startup was born',
  //     background: 'bg-blue-700',
  //     btnText: 'Follow Story',
  //     headerColor:'',
  //     titleSize: '',
  //     titleColor: '',
  //     descColor: '',
  //     descSize: '',
  //     btnColor: '',
  //     btnSize: '',
  //     svg: true,
  //   },
  // ]